<template>
    <BreadCrumb PageTitle="Liste de  règle" />
    <ListeRuleSet />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ListeRuleSet from "@/components/RulesSet/ListeRuleSet.vue";
  
    export default defineComponent({
      name: "AddRuleSetPage",
      components: {
        BreadCrumb,
        ListeRuleSet,
      },
    });
  </script>